import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import { PostsList } from "../../globals/core/List/PostsList";
import { privacyMap } from "../../globals/helpers/consts";
import { PostService } from "../../globals/services/post.service";
import { showLoader } from "../../store/actions/mainActions";
import { setModalChild } from "../../store/actions/modalActions";
import { AddNewContentForm } from "./AddNewContentForm";
import { QuickPostForm } from "./QuickPostForm";

export const ContentItemPreview = (props) => {

    const { currentContent } = useSelector((state) => state.content);

    const [posts, setPosts] = useState([])
    const [mounted, setMounted] = useState(true);
    const dispatch = useDispatch();

    const getRelatedPosts = useCallback(async () => {
        try {
            dispatch(showLoader(true))
            const postService = PostService();
            const posts = await postService.getPostsByContentId(currentContent.content_id)
            if (mounted) {
                setPosts(posts);
            }
            dispatch(showLoader(false))
        } catch (err) {
            dispatch(showLoader(false))
            console.error(err)
        }
    }, [setPosts, currentContent, mounted, dispatch])

    const renderTags = (tags) => {
        return tags ? tags.map((t, i) => (
            <div key={i} className="badge bg-light font-size-12 mx-2">
                <i className="bx bx-purchase-tag-alt align-middle text-muted me-1"></i>{" "}
                {t}
            </div>
        )) : null
    }

    // const setContentStatus = (status) => {
    //     const { afterPostAction } = props;
    //     dispatch(showLoader(true))
    //     const postService = PostService();
    //     postService.setContentStatus(currentContent.content_id, status)
    //         .then(() => {
    //             dispatch(showLoader(false))
    //             afterPostAction()
    //         })
    //         .catch(err => {
    //             dispatch(showLoader(false))
    //             console.error(err)
    //         })
    // }

    const republish = (post) => {
        const { afterPostAction } = props;
        dispatch(setModalChild(<QuickPostForm repost={post} action="create" afterPostAction={afterPostAction} />));
    }

    const editPost = (post) => {
        const { afterPostAction } = props;
        dispatch(setModalChild(<QuickPostForm repost={post} action="edit" afterPostAction={afterPostAction} />));
    }

    const renderPostUnits = (posts) => {
        return <PostsList posts={posts} republish={republish} editPost={editPost} />
    }

    const openQuickPostForm = () => {
        const { afterPostAction } = props;
        dispatch(setModalChild(<QuickPostForm action="create" afterPostAction={afterPostAction} />));
    }

    const openEditContentModal = () => {
        const { afterPostAction } = props;
        dispatch(setModalChild(<AddNewContentForm afterPostAction={afterPostAction} />));
    };

    const renderDetails = (content) => {
        return (
            <Row className="align-items-center">
                <Col sm={3}>
                    <div>
                        <p className="text-muted mb-0">Who can see this?</p>
                        <h5 className="font-size-15">{typeof content.who_can_see !== 'undefined' ? privacyMap[content.who_can_see]?.label : ''}</h5>
                    </div>
                </Col>
                <div className="col-1 d-none d-md-inline-block">
                    |
                </div>
                <Col sm={3}>
                    <div className="mt-4 mt-sm-0">
                        <p className="text-muted mb-0">Created</p>
                        <h5 className="font-size-15">{content.created}</h5>
                    </div>
                </Col>
                <div className="col-1 d-none d-md-inline-block">
                    |
                </div>
                <Col sm={3}>
                    <div className="mt-4 mt-sm-0">
                        <p className="text-muted mb-0">Uploaded by</p>
                        {/*<h5 className="font-size-15">{content.createdBy.fullName}</h5>*/}
                    </div>
                </Col>
            </Row>
        )
    }

    useEffect(() => {
        getRelatedPosts()
        return () => {
            setMounted(false)
        }

    }, [getRelatedPosts, setMounted])

    return (
        <Container>
            <Row>
                <Col lg={12}>
                    <Card>
                        <CardBody>
                            <div className="pt-3">
                                <div className="row justify-content-center">
                                    <div className="col-xl-8 d-block w-100 px-0 px-md-5">
                                        <div className="">
                                            <div className="my-5">
                                                <h5>Publish in your community</h5>
                                                <h4>{currentContent.title}</h4>
                                            </div>
                                            <div className="">
                                                {renderDetails(currentContent)}
                                            </div>
                                            <div className="row my-5">
                                                <div className="col-8">
                                                    <div className="text-muted font-size-14">
                                                        {currentContent.description}
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <img
                                                        src={currentContent?.thumbnail}
                                                        alt=""
                                                        className="img-thumbnail mx-auhref d-block"
                                                    />
                                                </div>
                                            </div>
                                            <div className="">
                                                {renderTags(currentContent.tags)}
                                            </div>
                                            <div className="row my-5">
                                                {renderPostUnits(posts)}
                                            </div>
                                            <div className="row mt-5 mb-3 justify-content-end">
                                                <div className="col-6 d-flex justify-content-start">
                                                    <Button color="danger" className="w-md mx-2">Delete</Button>
                                                </div>
                                                <div className="col-6 d-flex justify-content-end">
                                                    <Button onClick={openQuickPostForm} color="success" className="w-md mx-2">Publish</Button>
                                                    {currentContent.type !== "quick_post" ? <Button onClick={openEditContentModal} color="primary" className="w-md">Edit Content</Button> : null}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    )

}